import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';
import { httpErrorStatusCodes } from '@stillmandigital/common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly _authService = inject(AuthService);

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let nextRequest = request;

    if (nextRequest.url.startsWith(environment.apiBasePath)) {
      nextRequest = nextRequest.clone({
        headers: nextRequest.headers.set(
          'Authorization',
          `Bearer ${this._authService.getToken()}`,
        ),
      });
    }

    return next.handle(nextRequest).pipe(
      catchError(error => {
        if (error?.error?.message === 'TWO_FA_CODE_IS_EMPTY') {
          this._authService.set2FAAuth();
        } else if (
          error.status === httpErrorStatusCodes.unauthorized &&
          this._authService.isLoggedIn()
        ) {
          this._authService.logOut();
        }

        return throwError(error);
      }),
    );
  }
}
